import {AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {Subscription, fromEvent} from 'rxjs';
import {MarketCategory} from '@app/marketplace/categories/_models/category.interface';
import {Store} from '@ngrx/store';
import {UrlService} from '@app/services/url.service';
import {Meta, Title} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {isPlatformBrowser} from '@angular/common';
import * as categoriesSelectors from '@app/marketplace/categories/state/category/categories-selectors';
import * as categoriesActions from '@app/marketplace/categories/state/category/categories-actions';
import {_seoContent} from '@app/marketplace/seo-content/utils';
import {ConfigurationPagedSelectorModel, PaginationSelectorModel} from '@app/marketplace/shared/_models/pagination-selector.model';
import {ConfigurationPagedComponent, PaginatorComponent} from '@app/marketplace/shared/_components/paginator.component';

@Component({
  selector: 'app-category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.css']
})
export class CategoryListComponent extends ConfigurationPagedComponent<MarketCategory> implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('selectItems', { static: false })
  selectItems: ElementRef;
  payload: any;
  categoriesLocalInfo = _seoContent.map(x => ({code: x.categoryCode, name: x.sectionId}));
  protected _subscriptions: Subscription[] = [];
  constructor(
    private store: Store<any>,
    private urlService: UrlService,
    private metaService: Meta,
    private titleService: Title,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId) {
    super(route, metaService, titleService, router, store, platformId,
      new ConfigurationPagedSelectorModel(categoriesSelectors.selectLoading, categoriesSelectors.selectItems, categoriesSelectors.selectPageSize
      , categoriesSelectors.selectPageNo, categoriesSelectors.selectTotalPage, categoriesSelectors.selectTotalData, categoriesSelectors.selectCount, categoriesSelectors.selectConfiguration));
  }

  ngOnInit(): void {
    this.title = 'Cubatel Market | Tu tienda de envíos a Cuba';
    this.description = '¡Somos el Amazon cubano! Descubre nuestras tiendas online para comprar en Cuba desde el exterior. Entregamos a domicilio en todas las provincias cubanas.';
    this.keywords = 'tiendas online para envíos a cuba, amazon cubano, amazon en cuba, tiendas de envíos a cuba, tienda de envíos a cuba, envío a cuba online, tiendas online con envío a cuba, compras online en cuba desde el exterior, tiendas online en cuba para comprar desde el exterior, tiendas de envíos a cuba online, tiendas virtuales en cuba para comprar desde el exterior, compras online para cuba desde el exterior, tiendas online para comprar en cuba desde el exterior, compras desde el exterior para cuba';
    this.h1 = '';
    this.loadPrerender();
    this.payload= {
      "pageIndex": 1,
      "pageSize": 20,
      "pagingStrategy": 0,
      "locationType": 0,
      "locations": null,
      "locationResolver": false,
      "filter": {
        "searchTerms": "",
        "sortingArgs": 0,
        "categories": null,
        "priceRange": {
          "low": 1,
          "high": 250
        }
      },
      "categoryCode": '',
      "supplierCode": ""
    };
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
      this.store.dispatch(categoriesActions.ListCategories({ payload: this.payload}));
    }
    this.urlService.changeUrl(this.router.url);
    this.urlService.footer.emit();
  }
  getSlug(key: string): string {
    return this.categoriesLocalInfo.find(x => x.code == key)?.name || key;
  }
  pageChange($event: number) {
    this.payload.pageIndex = $event;
    this.store.dispatch(categoriesActions.ListCategories({ payload: this.payload}));
  }

  categoryAction(category: any) {
    if (category.hasChildren) {
      this.payload.parentCode = category.code;
      this.payload.pageSize = Number(this.selectItems.nativeElement.value);
      this.store.dispatch(categoriesActions.ListCategories({ payload: this.payload}));
    } else {
      this.store.dispatch(categoriesActions.ListProductsByCategory({ code:category.code,name:category.name}));
      this.router.navigate([`/market/tienda-online-cuba/${this.getSlug(category.code) || category.code}`]);
    }
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      fromEvent(this.selectItems.nativeElement, 'change')
        .subscribe(() => {
          this.payload.pageSize = Number(this.selectItems.nativeElement.value);
          this.store.dispatch(categoriesActions.ListCategories({ payload: this.payload}));
        });
    }
  }

  cancelRequest = () => this.store.dispatch(categoriesActions.CancelRequestCategories());

  ngOnDestroy(): void {
    this._subscriptions.forEach(sb => sb.unsubscribe());
    this.cancelRequest();
  }

}
